import MessagesTable from "../../../../components/MessagesTable";

const MessagesRightSide = () => {
  return (
    <>
      <MessagesTable />
    </>
  );
};

export default MessagesRightSide;
